import { LoadType } from '@thive/fddm-types';

export const mmToMetersLoadType = (loadType: LoadType): LoadType => ({
  id: loadType.id,
  category: loadType.category,
  length: loadType.length,
  width: loadType.width,
  height: loadType.height,
  maxHeight: loadType.maxHeight,
  weight: loadType.weight,
  imgUrl: loadType.imgUrl,
});
